import { LocalDateTime } from "@js-joda/core";
import { globalize } from "./translate";

/**
 * Formats a value in cents to a string
 *
 * 300 => "$3"
 * 399 => "$3.99"
 * 301 => "$3.01"
 */
export function formatPriceUSD(price: number, withSymbol = true): string {
  const symbol = withSymbol ? "$" : "";

  if (price % 100 === 0) {
    return symbol + price / 100;
  } else {
    const dollars = Math.floor(price / 100);
    const cents = price % 100;
    if (cents >= 10) {
      return symbol + dollars + "." + cents;
    } else {
      return symbol + dollars + ".0" + cents;
    }
  }
}

/**
 * @param day 0:Sun, 1:Mon, 2:Tue, 3:Wed, 4:Thu, 5:Fri, 6:Sat
 */
export function formatDay(day: number): string {
  // <https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md#optionsraw>
  // <http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table>

  // January 1, 2006 is a Sunday
  return globalize().formatLocalDateTime(LocalDateTime.of(2006, 1, day + 1), { raw: "EEEE" });
}

/**
 * Format number accirding to the browser locale
 */
export const formatNumberLocale = (num: Number) => {
  return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
};
